import { Component, Inject, OnInit } from '@angular/core';
import { IMoveContactUploadItem } from '../../../store/models/contact.model';
import { DataSourceParams, ITableColumn } from '../../../store/models/table.model';
import { StaticDataSource } from '../../../datasources/static.datasource';
import { DIALOG_COMPONENT, DialogComponent } from '../../../shared/ui/dialog/dialog.component';
import { ButtonColor, ButtonSize } from '../../../store/models/button.model';
import { ContactsService } from '../../../store/services/contacts.service';
import { Store } from '@ngrx/store';
import { IReducers } from '../../../store/reducers';
import { openSnackbar } from '../../../store/actions/page.action';

@Component({
  selector: 'app-upload-confirmation-dialog',
  templateUrl: './upload-confirmation-dialog.component.html',
  styleUrls: ['./upload-confirmation-dialog.component.scss'],
})
export class UploadConfirmationDialogComponent implements OnInit {
  items: IMoveContactUploadItem[] = [];

  tableColumns: ITableColumn<IMoveContactUploadItem>[] = [];

  dataSource: StaticDataSource<IMoveContactUploadItem>;
  dataSourceParams: DataSourceParams = {
    page: 1,
    pageSize: 10,
    filters: {},
    sortDir: 'desc',
    sortAttr: 'account_id',
  };

  private moveStarted: boolean;

  constructor(
    @Inject(DIALOG_COMPONENT) private readonly dialogComponent: DialogComponent,
    private readonly contactsService: ContactsService,
    private readonly store$: Store<IReducers>,
  ) {
  }

  ngOnInit(): void {
    this.tableColumns = [
      {
        id: 'contact_account_id',
        title: 'Source Account ID',
      },
      {
        id: 'account_id',
        title: 'Destination Account ID',
      },
      {
        id: 'contact_email',
        title: 'Email',
      },
      {
        id: 'contact_id',
        title: 'Contact ID',
      },
      {
        id: 'destination_group',
        title: 'Destination Group',
        renderer: (item: IMoveContactUploadItem) => {
          return (
            (item.destination_group || '') +
            (item.group_to ? ` (${item.group_to})` : '')
          );
        },
      },
      {
        id: 'error',
        title: 'Status',
        renderer: (item: IMoveContactUploadItem) => {
          return item.error ? item.error : 'Ready to be moved';
        },
      },
      {
        id: 'moved_result',
        title: 'Result',
        disabled: !this.moveStarted,
      },
    ];
    if (this.items && this.items.length) {
      this.dataSource = new StaticDataSource<IMoveContactUploadItem>(
        this.items,
      );

      if (this.items.filter(i => !!i.error).length !== this.items.length) {
        this.dialogComponent.setButtons([
          {
            text: 'Move',
            color: ButtonColor.BLUE,
            size: ButtonSize.NORMAL,
            onClick: () => this.moveContacts(),
          },
        ]);
      }
    }
  }

  moveContacts() {
    const contacts = this.items.filter(i => !i.error).map(i => i.contact_id);
    const accounts = this.items.filter(i => !i.error).map(i => i.account_id);

    this.contactsService.moveContactsToAccounts(contacts, accounts)
      .subscribe(response => {
        this.moveStarted = true;
        if (response.failed && response.failed.length) {
          response.failed.forEach(c => {
            for (let i = 0; i < this.items.length; i++) {
              if (+this.items[i].contact_id === c.contact_id) {
                this.items[i].error = c.message;
              }
            }
          });
        }

        if (response.moved && response.moved.length) {
          response.moved.forEach(c => {
            for (let i = 0; i < this.items.length; i++) {
              console.log('here 2', +this.items[i].contact_id, c.contact_id);
              if (+this.items[i].contact_id === c.contact_id) {
                this.items[i].error = c.message;
              }
            }
          });
        }

        this.dataSource.refresh();
        this.dialogComponent.setButtons([]);
        this.store$.dispatch(openSnackbar({
          snackbarData: {
            data: {
              message: 'Move operation successfully initiated. Please, check the results in Status column',
              type: 'success',
            },
          },
        }));
      });
  }
}
